module.exports = __webpack_public_path__ + "static/media/fb.898a1640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/fb.svg
// module id = 95
// module chunks = 0